var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transactions"},[_c('b-row',[_c('b-col',[_c('b-alert',{attrs:{"variant":"success","show":""}},[_vm._v("Coming soon")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }